import type { CSSObject } from '@emotion/react'
import { Color, FocusIndicator, Size, Spacing, Typography } from '@opallabs/gem'
import type { StyleProps } from './types'

export const wrapperStyles = ({ theme }: StyleProps): CSSObject => ({
  ...Typography.T500,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingInline: Spacing.XS * 5,
  background: Color[theme].Surface.N000,
  color: Color[theme].Text.Default,
  blockSize: Spacing.M * 6.125,
  userSelect: 'none',
})

export const leftWrapperStyles: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  inlineSize: '100%',
}

export const textWrapperStyles: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  marginInlineStart: Spacing.XS * 5,
  cursor: 'default',
  userSelect: 'none',
}

export const userNameStyles: CSSObject = {
  fontSize: Typography.H300.fontSize,
}

export const rightWrapperStyles = ({ theme }: StyleProps): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  color: Color[theme].Surface.N600,
})

export const buttonStyles = ({ theme }: StyleProps): CSSObject => ({
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: Size.Rounding * 0.75,
  color: Color[theme].Surface.N600,
  cursor: 'pointer',
  flex: '0 0 auto',
  paddingBlock: Spacing.XS * 1.25,
  paddingInline: Spacing.XS * 1.25,

  '&:active': {
    backgroundColor: Color[theme].Surface.N500,
  },
  '&:active, &:focus': {
    ...FocusIndicator[theme],
  },
  '&:focus, &:hover': {
    backgroundColor: Color[theme].Surface.N300,
    color: Color[theme].Text.Default,
  },
})

export const closeButtonStyles = ({ theme }: StyleProps): CSSObject => ({
  ...buttonStyles({ theme }),
  margin: Spacing.XS * -1.25,
  marginBlockEnd: Spacing.XS * 1.75,
})
